export default "__VITE_ASSET__505d1ec0__"